export const PENDING = actionType => `${actionType}_PENDING`
export const FULFILLED = actionType => `${actionType}_FULFILLED`
export const REJECTED = actionType => `${actionType}_REJECTED`
